import { UnAuthAPIName } from 'src/constants';
import { PaymentFees } from 'src/store/payments/types';
import { API } from 'src/utils/AmplifyApiUtils';

import { ApiTags, appAPI } from '.';

export const paymentFeesApi = appAPI.injectEndpoints({
  endpoints: (build) => ({
    getPaymentFees: build.query<PaymentFees, void>({
      queryFn: async () => {
        try {
          const data = await API.get(UnAuthAPIName, '/public/payment-fee', {});
          return { data };
        } catch (error) {
          return { error };
        }
      },
      providesTags: [ApiTags.payment_fees],
    }),
  }),
});

export const { useGetPaymentFeesQuery } = paymentFeesApi;
